import config from '../../../../config';
import { AddDistributor } from '../../../domainModels/distributors/AddDistributor';
import { Distributor } from '../../../domainModels/distributors/Distributor';
import { UpdateDistributor } from '../../../domainModels/distributors/UpdateDistributor';
import { axiosInstance as axios } from '../../axios/axiosInstance';

export const distributorsEndpoint = `${config.tachoAPI.url}/distributors`;

export const getDistributors = (): Promise<Array<Distributor>> => {
    return axios
        .get<Array<Distributor>>(distributorsEndpoint)
        .then(response => {
            return response.data;
        })
        .catch(err => {
            throw Error(getDistributors.name + err);
        });
};

export const createDistributor = (distributor: AddDistributor): Promise<boolean> => {
    return axios
        .post<AddDistributor>(distributorsEndpoint, distributor)
        .then(response => {
            return true;
        })
        .catch(error => {
            if (error.response!.status === 409) {
                throw Error('distributorsConflictedEmail');
            }

            throw Error(createDistributor.name + error);
        });
};

export const updateDistributor = (distributor: UpdateDistributor): Promise<UpdateDistributor> => {
    return axios
        .patch<UpdateDistributor>(`${distributorsEndpoint}/${distributor.distributorId}`, distributor)
        .then(response => {
            return distributor;
        })
        .catch(error => {
            throw Error(updateDistributor.name + error);
        });
};

export const removeDistributor = (distributorId: string): Promise<string> => {
    return axios
        .delete(`${distributorsEndpoint}/${distributorId}`)
        .then(response => {
            return distributorId;
        })
        .catch(error => {
            throw Error(removeDistributor.name + error);
        });
};
